import { wrapFetch } from '../libs/fetch';

export interface CreateProspectiveUserRequest {
  email: string;
  admin_brand_id?: number;
  recruitment_id?: number;
}

export interface CreateProspectiveUserResponse {
  id: number;
  email: string;
  message?: string;
}

export const createProspectiveUser = async (
  data: CreateProspectiveUserRequest,
  csrfToken: string
): Promise<CreateProspectiveUserResponse> => {
  return await wrapFetch<CreateProspectiveUserResponse>('/api/v1/prospective_users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ prospective_user: data }),
    credentials: 'same-origin',
  });
};
